<template>
    <div>
        <table class="diff">
            <tbody>
            <tr v-for="row in diff">
                <td class="title-cell">
                    <span>{{ row.t }}:</span>
                </td>
                <td class="old-cell" align="right">
                    <div v-if="row.oldImages">
                        <template v-if="row.oldImages.length">
                            <a v-for="image in row.oldImages"
                               :href="image.orig"
                               target="_blank"
                            >
                                <img :src="image.little" alt="">
                            </a>
                        </template>
                        <span v-else>✕</span>
                    </div>
                    <div v-else-if="row.o">
                        <div v-for="line in nl2br(row.o)" :key="line.title">
                            {{ line }}
                        </div>
                    </div>
                    <span v-else>✕</span>
                </td>
                <td class="chevron-cell">
                    <i class="fa fa-chevron-right"></i>
                </td>
                <td class="new-cell">
                    <div v-if="row.newImages">
                        <template v-if="row.newImages.length">
                            <a v-for="image in row.newImages"
                               :href="image.orig"
                               target="_blank"
                            >
                                <img :src="image.little" alt="">
                            </a>
                        </template>
                        <span v-else>✕</span>
                    </div>
                    <div class="new-cell__list" v-else-if="row.n">
                        <div v-for="line in nl2br(row.n)" :key="line.title">
                            {{ line }}
                        </div>
                    </div>
                    <span v-else>✕</span>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    export default {
      name: "DetailLevelL",
      props: {
            diff: { type: Array, required: true },
            rowData: { type: Object, required: true },
        },
        methods: {
            nl2br(str) {
                if (str) {
                    return str.toString().split('\n');
                }
            },
        },
    }
</script>

<style scoped lang="scss">
    table.diff {
        width: 100%;
        tr {
            vertical-align: top;
            width: 100%;
            &:not(:last-child) {
                border-bottom: 1px rgba(0, 0, 0, 0.1) solid;
            }
            td {
                word-break: break-word;
                &.title-cell {
                    width: 123px!important;
                    min-width: 123px;
                    font-weight: bold;
                }
                &.old-cell {
                    width: 44%!important;
                }
                &.chevron-cell {
                    width: 20px;
                    text-align: center;
                    color: rgba(0, 0, 0, 0.2);
                }
                &.new-cell {
                    width: 44%!important;
                    &__list {
                        display: flex;
                        flex-direction: column;
                    }
                }
            }
        }
    }
</style>
